// extracted by mini-css-extract-plugin
module.exports = {"container":"_2BFB8","headline":"_2Kzg0","border":"_2r9oJ"};